// extracted by mini-css-extract-plugin
export default {"popperClass":"BPtCollapseCountry-module_popperClass_e2e289cc"};